import { Injectable } from '@angular/core';
import { JobDetailsDTO } from './job-details.dto';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { api } from '../api';
import { Storage } from '../constants';
import { JobApplyObject } from './job-apply-object.dto';
import { ResumeService } from '../resume/resume.service';
import { JobSearchService } from '../job-search/job-search.service';
import { TranslateService } from '@ngx-translate/core';
import 'rxjs/add/observable/throw';

declare const google: any;

@Injectable()
export class JobService {
  private applyJobObject: JobApplyObject;
  private jobApplicationStatus: number;
  public canUserApplyJob: boolean;
  public jobApplyalertData: any;
  public applyJobSuccessMessage: string;
  public trackRequest: number;
  public mapCenterLatitude: any;
  public mapCenterLongitude: any;
  public IsJobApplied: boolean;
  private remoteText: string;

  constructor(private http: HttpClient,
  private resumeService: ResumeService,
  private jobSearchService: JobSearchService,
  private translate: TranslateService
  ) {
    this.translate.get('REC_JOB_REMOTE').subscribe((obj) => {
    this.remoteText = obj;
    });
  }

  getJobDetails(jobId: number) {
    const httpParams: HttpParams = new HttpParams()
      .set('jobId', jobId.toString().split('?')[0]);
    if (window.localStorage.getItem(Storage.AUTH_TOKEN) != null) {
      return this.http.get(api.public.job.GET_JOB_DETAILS, { params: httpParams })
        .catch(this.handleError);
    } else {
      return this.http.get(api.public.job.GET_PUBLIC_JOB_DETAILS, { params: httpParams })
        .catch(this.handleError);
    }
  }

  private handleError(error: Response | any) {
    return Observable.throw(error);
  }

  setApplyJobObject(applyObject: JobApplyObject) {
    window.localStorage.setItem('jobApplyObject', JSON.stringify(applyObject));
  }

  getApplyJobObject(): JobApplyObject {
    if (window.localStorage.getItem('jobApplyObject') != null) {
      return JSON.parse(window.localStorage.jobApplyObject);
    }
  }

  setSuccessAlert(status: number) {
    this.jobApplicationStatus = status;
  }

  getSuccessAlert() {
    return this.jobApplicationStatus;
  }

  saveRequisitionAnswers(answers: any, applicationId: number, assessmentId: number) {

    const httpParams: HttpParams = new HttpParams()
      .set('requisitionApplicationId', applicationId.toString())
      .set('requisitionAssessmentId', assessmentId.toString());
    return this.http.post(api.requisition.REQUISITION_ASSESSMENT_SAVE, answers, {
      params: httpParams
    })
      .catch(this.handleError);
  }

  getAssessment(id: number) {
    const httpParams: HttpParams = new HttpParams()
      .set('requisitionAssessmentId', id.toString())
      .set('applicationId', '-1');
    return this.http.get(api.requisition.REQUISITION_ASSESSMENT, { params: httpParams })
      .catch(this.handleError);
  }
  getAssessmentWithAnswers(id: number, applicationId: number) {
    const httpParams: HttpParams = new HttpParams()
      .set('requisitionAssessmentId', id.toString())
      .set('applicationId', applicationId.toString())
      .set('assessmentObjectId', applicationId.toString())
      .set('objectType', '1');
    return this.http.get(api.requisition.REQUISITION_ASSESSMENT, { params: httpParams })
      .catch(this.handleError);
  }

  getCandidateAssessment(id: number) {
    const httpParams: HttpParams = new HttpParams()
      .set('requisitionAssessmentId', id.toString())
      .set('assessingPersonNumber', null)
      .set('assessmentObjectId', id.toString())
      .set('objectType', '2');
    return this.http.get(api.requisition.REQUISITION_CANDIDATEASSESSMENT, { params: httpParams })
      .catch(this.handleError);
  }

  getAssessmentIdForRequisition(id: number) {
    const httpParams: HttpParams = new HttpParams()
      .set('requisitionID', id.toString())
      .set('isInternalPosting', 'false');
    return this.http.get(api.requisition.REQUISITION_ASSESSMENT_FOR_REQUISITION, { params: httpParams })
      .catch(this.handleError);
  }

  getSelfAssessmentForRequisition(id: number) {
    const httpParams: HttpParams = new HttpParams()
      .set('requisitionID', id.toString())
    return this.http.get(api.requisition.SELF_ASSESSMENT, { params: httpParams })
      .catch(this.handleError);
  }
  getInterviewDetails (id: number ) {
  const httpParams: HttpParams = new HttpParams()
  .set('id', id.toString());
  return this.http.get(api.candidate.INTERVIEW_DETAILS, { params: httpParams })
      .catch(this.handleError);
  }

 submitRequisitionAssessmentAnswers(answerList: any, requisitionId: number, resumeId: number, isSubmitted: boolean = true) {
    if (resumeId === undefined || resumeId === null) {
      resumeId = this.resumeService.getResumeId();
    }
    // Check if source exists in the service, if yes then add it to the params
    const jobApplyObject: JobApplyObject = this.getApplyJobObject();
    let httpParams: HttpParams = new HttpParams()
      .set('requisitionId', requisitionId.toString())
      .set('resumeId', resumeId.toString())
      .set('IsSubmitted', isSubmitted.toString());
      if (jobApplyObject.eQuestSource) {
        httpParams = httpParams.append('source', jobApplyObject.eQuestSource);
      }
    return this.http
      .post(api.requisition.REQUISITION_SUBMIT_ASSESSMENT_ANSWER, answerList, {
        params: httpParams
      })
      .catch(this.handleError);
  }

 applyRequisition(requisitionID: number, personId: string, isReApplyPreValidate: boolean) {
    const httpParams: HttpParams = new HttpParams()
      .set('requisitionID', requisitionID.toString())
      .set('isReApplyPreValidate', isReApplyPreValidate.toString());
  return this.http.get(api.requisition.RESTRICT_CANDIDATE_REAPPLY, { params: httpParams })
      .catch(this.handleError);
  }

  setJobcity(job: any) {
    let jobTitle: string[] ;
    if ( job !== undefined && job !== null) {
      const filters = this.jobSearchService.getJobFilters();
      const searchCity: string[] = [];
      const other: string[] = [];
      if (job.requisitionWorkLocations === undefined && job.city && job.city.length !== 0) {
        job.city.forEach((c: String, index: number) => {
          const lst = [];
          if(c !== '#') {
            lst.push(c);
          } else {
            lst.push(this.remoteText);
          }
          if(job.state[index] !== '#') {
            lst.push(job.state[index]);
          }
          lst.push(job.country[index]); 
          const findex = filters.findIndex( f => f.uncodedValue === c || 
            f.uncodedValue === job.state[index] || f.uncodedValue === job.country[index]);
          if (findex !== -1 ) {
            searchCity.push(lst.join(', '));
          } else {
            other.push(lst.join(', '));
          }
        });
      } else {
        if (job.requisitionWorkLocations !== undefined && job.requisitionWorkLocations.length != 0){
          job.requisitionWorkLocations.forEach((wl: { city: String; state: string, country: string}) => {
            const lst = [];
            if (wl.city) {
              lst.push(wl.city);
            } else {
              lst.push(this.remoteText);
            } 
            if (wl.state) {
              lst.push(wl.state);
            }
            lst.push(wl.country);
            const index =filters.findIndex( f => f.uncodedValue === wl.city || 
              f.uncodedValue === wl.state || f.uncodedValue === wl.country)
            if (index !== -1 ) {
              searchCity.push(lst.join(', '));
            } else {
              other.push(lst.join(', '));
            }
          });
        }
      }
      jobTitle = searchCity.concat(other);
    }
    return jobTitle;
  }

  isNullOrEmpty(value: string) {
    return value === null || value === '';
  }

  setMapCenter(location) {
      if (location.latitude !== undefined && location.latitude !== null
        && location.longitude !== undefined && location.longitude !== null) {
        this.mapCenterLatitude = location.latitude;
        this.mapCenterLongitude = location.longitude;
      } else {
        const geocoder = new google.maps.Geocoder();
        const mapCenterAddress = this.concatStrings([location.address1, location.address2, location.city,
          location.state, location.country, location.postalCode], ', ', );
          geocoder.geocode({ 'address': mapCenterAddress }, (results, status) => {
            if (status === 'OK') {
              this.mapCenterLatitude = results[0].geometry.location.lat();
              this.mapCenterLongitude = results[0].geometry.location.lng();
            }
          });
        }
    }

    private concatStrings(inputString, concatChar) {
      let outputString = [];
      inputString.forEach(element => {
        if (element) {
          outputString = outputString.concat(element.trim());
        }
      });
      return outputString.join(concatChar);
    }
}



// WEBPACK FOOTER //
// ../UI/src/app/shared/job/job.service.ts